"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adamant = void 0;
exports.adamant = {
    multiFeeDistribution: "0x920f22E1e5da04504b765F8110ab96A20E6408Bd",
};
